export enum CompanyRegistrationType {
  Company = 'Company',
  Individual = 'Individual',
  Other = 'Other',
}
